"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SearchServiceResponse", {
    enumerable: true,
    get: function() {
        return SearchServiceResponse;
    }
});
const _zod = require("zod");
const _employee = require("./employee");
const _meeting = require("./meeting");
const _reviewcyclelog = require("./review-cycle-log");
const _scimlog = require("./scim-log");
const _survey = require("./survey");
const SearchServiceResponse = _zod.z.union([
    _meeting.ActionItemSearchServiceResponse,
    _employee.GetEmployeeSearchServiceResponse,
    _meeting.GetMeetingSearchServiceResponse,
    _meeting.GetMeetingWorkspaceSearchServiceResponse,
    _reviewcyclelog.GetReviewCycleLogSearchServiceResponse,
    _scimlog.GetScimLogSearchServiceResponse,
    _survey.GetSurveySearchServiceResponse
]);
